import { render, staticRenderFns } from "./PricelistsView.vue?vue&type=template&id=28b6d260&"
import script from "./PricelistsView.vue?vue&type=script&lang=js&"
export * from "./PricelistsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports